import React, { useState } from "react";

const Dropdown = ({ options, selectedOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };
  console.log(selectedOption);
  return (
    <div className="relative inline-block text-left w-full ">
      <div>
        <span className="rounded-md shadow-sm">
          <button
            type="button"
            className="flex justify-center w-full rounded-md border text-white border-gray-300 h-[48px] items-center bg-gray-700 px-4 py-2 text-sm font-medium text-gray-700 focus:outline-none focus:border-blue-500"
            onClick={toggleDropdown}
          >
            {selectedOption?.name ? selectedOption?.name : selectedOption?.value ? selectedOption?.value : 'select an option'}
            <svg
              className="-mr-1 ml-2 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M6.293 7.293a1 1 0 011.414 0L10 9.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </span>
      </div>

      {isOpen && (
        <div className="origin-top-right absolute w-full right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10">
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            <button
                key={0}
                // onClick={() => handleOptionSelect(option)}
                className="block px-4 py-2 text-sm bg-gray-700 text-center text-white text-gray-600 w-full text-left focus:outline-none"
                // role="menuitem"
                disabled
              >
                select an option
              </button>
            {options?.map((option, index) => (
              <button
                key={index}
                onClick={() => handleOptionSelect(option)}
                className="block px-4 py-2 text-sm bg-gray-700 text-white text-gray-700 hover:bg-gray-100 hover:text-gray-800 w-full text-left focus:outline-none"
                role="menuitem"
              >
                {option.name || option.value}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dropdown;
